import { BetTypes } from "../../../types";
export const isComboBet = (betType) => {
    return betType === BetTypes.Combo;
};
//# sourceMappingURL=isComboBet.js.map